import {VnRegionConfig} from '@frontend/locales/regions/VnRegionConfig'
import type {RegionConfig} from '@frontend/types/Locales'

export const DemoRegionConfig: RegionConfig = {
    region: 'demo',
    defaultLanguage: 'en',
    label: 'Demo',
    variations: ['demo'],
    logoSubtitle: 'Demo',
    defaultCity: 'Dubai',
    demoAdvertisement: {
        price: 15,
        previousPrice: 30,
        discountPercent: 50,
    },
    currencyCode: 'USD',
    numeral: {
        localeConfig: {
            currency: {
                symbol: '$',
            },
        },
        defaultFormat: '0,0[.]00$',
    },
    phone: {
        template: '(___) ___-__-__',
        minCursorPosition: 1,
        validationRegexp: /^\(?\d\d\d\)?\s*\d{3}-?\d{2}-?\d{2}$/,
    },
    verificationCode: VnRegionConfig.verificationCode,
    allowedEmailDomains: [
        'gmail.com',
        'yahoo.com',
        'icloud.com',
        'hotmail.com',
    ],
    clientSurvey: {
        ...VnRegionConfig.clientSurvey,
        drivingLicense: {
            minLength: 10,
            maxLength: 10,
            allowedChars: /\d/,
            validationRegexp: /^\d{10}$/,
        },
    },
    contacts: {
        phone: '1900 9898 44',
        email: 'support@dotoku.com',
        facebook: 'https://www.facebook.com/dotokuvietnam/?locale=vi_VN',
        zalo: 'https://zalo.me/dotokuvietnam19',
    },
    moneyInput: {
        numeralFormat: '0,0[.]00',
        numeralFormatForPriceFilter: '0,0',
        allowedChars: /[0-9,.]/,
    },
    birthDate: {
        minAge: 18,
        maxAge: 65,
    },
    adPrice: {
        maxDigits: 8,
        maxValue: 99000000,
        minValue: 1,
    },
    adDescription: VnRegionConfig.adDescription,
    googleMaps: {
        adCreationForm: {
            defaultCenter: {
                lat: 25.276987,
                lng: 55.296249,
            },
            defaultZoom: 8,
            addressZoom: 15,
        },
    },
    splitFullUserName(fullName: string): {
        firstName: string | null
        lastName: string | null
    } {
        const parts: string[] = fullName.trim().split(/[\s.,:]+/)
        return {
            firstName: parts.length > 0 ? parts[0] : null,
            lastName: parts.length > 1 ? parts.slice(1).join(' ') : null,
        }
    },
    makeFullUserName(firstName: string | null, lastName: string | null): string {
        return `${firstName ?? ''} ${lastName ?? ''}`.trim()
    },
    addLetterVariationsToKeywords(keywords: string): string {
        return keywords
    },
}
